const UNITS: [RegExp, number, string][] = [
  [/^seconds?$/, 1, 's'], [/^minutes?$/, 60, 'min'], [/^hours?$/, 3600, 'h'], [/^days?$/, 86_400, 'j'],
  [/^weeks?$/, 604_800, 'sem.'], [/^months?$/, 2_592_000, 'mois'], [/^years?$/, 31_536_000, 'ans'],
];

export type ContainerHealth = 'healthy' | 'unhealthy' | 'starting';

/**
 * How long a container has been up, from Docker's status (« Up 3 days (healthy) »,
 * « Up About an hour », « Exited (0) 2 hours ago »): seconds for sorting, a short
 * label, and its health check when it has one.
 */
export function uptime(status: string): { seconds: number | null; label: string; health: ContainerHealth | null } {
  const health = /\(healthy\)/i.test(status) ? 'healthy' : /\(unhealthy\)/i.test(status) ? 'unhealthy' : /health: starting/i.test(status) ? 'starting' : null;
  const up = status.match(/^Up\s+(.+?)(?:\s*\(.*\))?$/i);
  if (!up) return { seconds: null, label: '—', health };
  const text = up[1]!.trim();
  if (/^less than a second$/i.test(text)) return { seconds: 0, label: '< 1 s', health };
  const m = text.match(/^(about an?|an?|\d+)\s+(\w+)$/i);
  const unit = m && UNITS.find(([pattern]) => pattern.test(m[2]!.toLowerCase()));
  if (!m || !unit) return { seconds: null, label: text, health };
  const n = /^\d+$/.test(m[1]!) ? Number(m[1]) : 1;
  return { seconds: n * unit[1], label: `${/^about/i.test(m[1]!) ? '≈ ' : ''}${n} ${unit[2]}`, health };
}
